import api from '../api'
import { showAppErrorModal } from './modals'

export function imageSearch(searchTerm, count, offset) { // Plickers image search
  return (dispatch) => api.fetchImageSearchResults(searchTerm, count, offset)
    .then((response) => response)
    .catch((error) => { // TODO better error handling
      if (error.response && error.response.status === 403) { // 403 can occur when exceed queries quota.
      } else {
        dispatch(showAppErrorModal('imageSearch'))
      }
      throw error
    })
}

export function gifSearch(searchTerm, limit, offset) {
  return () => api.fetchGifSearchResults(searchTerm, limit, offset)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

// Fetch all gif details from GIPHY API (when select GIF from search results we fetch all details before inserting)
export function fetchGifById(gifId) {
  return () => api.fetchGifById(gifId)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}
